import React, {useState, useEffect} from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import Inputfield from '../InputField/Inputfield'
import Radiofield from '../Radiofield/Radiofield'
import '../Addemployee/addemployee.css'
import './addepartment.css'
import axios from 'axios'
import { useCookies } from 'react-cookie';

const Addepartment = ({sendnotice, params, empselect}) => {
  let newstaffArray = []

    empselect.allStaffs.map(staffObj => (
      newstaffArray.push({ID: staffObj.ID, name: staffObj.first_name + ' ' + staffObj.last_name})
    ))

    const API = 'https://staging.sabrecwa.com/staff'
    const [cookies] = useCookies(['Token']);
    const [values, setValues] = useState({
        deptartmentname: '',
        deptartmenthead: '',
    })

    useEffect(() =>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    // console.log(`Obaloluwa: ${JSON.stringify(params)}`)

    const handleClose = () =>{
        sendnotice({
          action: "close",
          text: ''
        })
    }

    const handleSubmit = (e) =>{
        e.preventDefault()
        // Submit Data
        if(params.id !== undefined || params.id > 0){
            // console.log("edit command")
            UpdateRequest(params.id)
        } else{
            // console.log("normal open")
            UpdateRequest(undefined)
        }
    }

    const UpdateRequest = async(props) =>{
        sendnotice({
          action: "load",
          text: 'Sending Broadcast...'
        })
        try {
          var config = {
            method: props !== undefined ? 'PUT' : 'POST',
            url: props !== undefined ? `${API}/updatempList/${props}` : `${API}/hr/create/department`,
            data: {
              name: values.deptartmentname,
              department_head: values.deptartmenthead
            },
            headers: { 
              Authorization: "Bearer " + cookies.Token
            }
          };

          // console.log(config)
      
          await axios(config).then((response) => {
          // console.log(response.data.data);
            if(response.data.success === true){
              sendnotice({
                action: "notload",
                text: response.data.message
              })
            }
          });
        } catch(e){
          if(e.message.includes('401')){
            // catch error
          } else{
            // catch error
          }
        }
    }

    const handleDeptname = (incoming) =>{
      setValues({...values, deptartmentname: incoming})
    }

    const handleDepthead = (incoming) =>{
      setValues({...values, deptartmenthead: incoming})
    }

  return (
    <div className='overlay-container'>
            <div className='overlay-addemployee-container'>
                <div className='top-container-apprais-notif'>
                    <span>ADD NEW DEPARTMENT</span>
                    <AiOutlineCloseCircle id='closeIcon-notifc' onClick={handleClose}/>
                </div>

                <form onSubmit={handleSubmit} className='top-addemployee-container-body'>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield fieldlabel="Department" placehold="Enter Department here..." typeid="text" personname={handleDeptname}/>
                        </div>
                    </div>
                    <div className='addemployee-addrow'>
                        <div className='addemployee-addrow-cola'>
                            <Inputfield fieldlabel="Department Head" placehold="Select Head..." typeid="headsdropdwn" unithead={handleDepthead} EmployeeJson={newstaffArray}/>
                        </div>
                    </div>
                    <div className='top-addemployee-submit-row'>
                        <button id='broadcast-buttn' type='submit'>SUBMIT</button>
                    </div>
                </form>
            </div>
        </div>
  )
}

export default Addepartment